import React, { useState } from 'react';
import classNames from 'classnames';

import Icons from 'assets/icons';

interface ComparisonAccordionProps {
  title: string;
  children: React.ReactNode;
  /**
   * Each accordion owns its own expand state, so opening one never collapses another - the design
   * calls for independent panels rather than a single-open-at-a-time accordion.
   */
  defaultExpanded?: boolean;
  testId?: string;
}

const ComparisonAccordion = ({
  title,
  children,
  defaultExpanded = false,
  testId,
}: ComparisonAccordionProps): React.JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div
      className="border border-navy-100 rounded-md overflow-hidden"
      data-testid={testId}
    >
      <button
        type="button"
        className={classNames(
          'flex items-center gap-3 w-full px-3 py-2.5 hover:bg-gray-50 transition-colors',
          { 'border-b border-navy-100': isExpanded }
        )}
        onClick={() => setIsExpanded((prev) => !prev)}
        aria-expanded={isExpanded}
      >
        <Icons.Arrow
          className={classNames('size-3 shrink-0 text-gray-500', {
            'rotate-90': isExpanded,
          })}
          aria-hidden="true"
        />
        <span className="text-base font-bold text-gray-700 leading-6 text-left">
          {title}
        </span>
      </button>

      {isExpanded && <div className="p-3">{children}</div>}
    </div>
  );
};

export default ComparisonAccordion;
